<template>
  <div>
    <div class="container-fluid principal">
      <div class="row">
        <div class="col-md-12">
          <Dialog
            :baseZIndex="2222"
            :visible.sync="userDialog"
            :style="{ width: '300px' }"
            header="New User"
            :modal="true"
            :contentStyle="{ height: '250px' }"
            class="p-fluid"
          >
            <div class="p-field">
              <label for="email">Email</label>
              <InputText
                id="email"
                v-model="user_model.user_email"
                required="true"
                :class="{
                  'p-invalid': newUserSubmitted && invalid.user_email,
                }"
              />
              <small
                class="p-invalid"
                v-if="newUserSubmitted && invalid.user_email"
              >
                Please complete this field.
              </small>
            </div>
            <br />
            <div class="p-field">
              <label for="profile">
                <Dropdown
                  id="profile"
                  required="true"
                  v-model="user_model.profile_id"
                  :options="profiles"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Choose a Profile"
                  @input="getSingleProfile(user_model.profile_id)"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>

                <small
                  class="p-invalid"
                  v-if="newUserSubmitted && invalid.profile_id"
                >
                  Please complete this field.
                </small>
              </label>
            </div>
            <template #footer>
              <Button
                v-if="!load_creation"
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                @click="hideUserDialog"
              />
              <Button
                v-if="!load_creation"
                label="Save"
                icon="pi pi-check"
                class="p-button-text"
                @click="saveNewUser"
              />
              <ProgressSpinner
                v-else
                style="width: 50px; height: 50px"
                strokeWidth="8"
                fill="#EEEEEE"
                animationDuration=".5s"
              /> </template
          ></Dialog>

          <Dialog
            :baseZIndex="2222"
            :visible.sync="deleteUserDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="user">
                Are you sure you want to delete this data?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteUserDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteSelectedUser"
              /> </template
          ></Dialog>
          <Toast position="top-right" :baseZIndex="2222" />
          <div class="row">
            <div class="col-md-12">
              <Toolbar class="p-mb-4">
                <template #left>
                  <div class="row">
                    <div class="col-md-12">
                      <Button
                        label="Add"
                        icon="pi pi-plus"
                        class="p-button-success p-mr-2"
                        @click="openUserDialog"
                      />
                    </div>
                  </div>
                </template>
              </Toolbar>
              <div class="card">
                <DataTable
                  :value="users"
                  editMode="row"
                  dataKey="user_id"
                  :editingRows.sync="editingRows"
                  :loading="principal_data_table_loading"
                  class="p-datatable-striped"
                  :scrollable="true"
                  :paginator="true"
                  :rows="10"
                  :filters="filters"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  :rowsPerPageOptions="[5, 10, 25]"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
                  @row-edit-init="onRowEditInit"
                  @row-edit-cancel="onRowEditCancel"
                  @row-edit-save="onRowEditSave"
                >
                  <template #header>
                    <div class="table-header-container">
                      <h5 class="p-m-0">Users</h5>
                      <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText
                          v-model="filters['global']"
                          placeholder="Search..."
                        />
                      </span>
                    </div>
                  </template>
                  <Column
                    field="user_email"
                    header="User"
                    headerStyle="width: 175px"
                    bodyStyle="width: 175px;"
                  >
                    <template #editor="slotProps">
                      {{ slotProps.data[slotProps.column.field] }}
                    </template>
                  </Column>
                  <Column
                    field="profile_details.profile_name"
                    header="Profile"
                    headerStyle="width: 175px"
                  >
                    <template #editor="slotProps">
                      <Dropdown
                        v-if="slotProps.data.user_email != user_login"
                        v-model="slotProps.data['profile_id']"
                        :options="profiles"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Choose a Profile"
                        @input="getSingleProfile(slotProps.data['profile_id'])"
                      >
                        <template #option="slotProps">
                          <span>{{ slotProps.option.label }}</span>
                        </template>
                      </Dropdown>
                      <span v-else>{{
                        slotProps.data.profile_details.profile_name
                      }}</span>
                    </template>
                  </Column>
                  <Column
                    field="user_enabled"
                    header="Status"
                    headerStyle="width: 175px"
                    bodyStyle="width: 175px;"
                  >
                    <template #body="slotProps">
                      <span v-if="slotProps.data.user_enabled">
                        <Avatar shape="circle" class="avatar-green">
                          <i class="pi pi-check-circle icon-white"></i>
                        </Avatar>
                      </span>
                      <span v-else>
                        <Avatar shape="circle" class="avatar-red">
                          <i class="pi pi-times-circle icon-white"></i>
                        </Avatar>
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <InputSwitch
                        v-if="slotProps.data.user_email != user_login"
                        v-model="slotProps.data[slotProps.column.field]"
                      />
                      <div v-else>
                        <span v-if="slotProps.data.user_enabled">
                          <Avatar shape="circle" class="avatar-green">
                            <i class="pi pi-check-circle icon-white"></i>
                          </Avatar>
                        </span>
                        <span v-else>
                          <Avatar shape="circle" class="avatar-red">
                            <i class="pi pi-times-circle icon-white"></i>
                          </Avatar>
                        </span>
                      </div>
                    </template>
                  </Column>
                  <Column
                    :rowEditor="true"
                    headerStyle="width: 7rem"
                    bodyStyle="width: 7rem; text-align:center;"
                  ></Column>

                  <Column
                    v-if="can_show_actions"
                    headerStyle="width: 7rem"
                    bodyStyle="width: 7rem; text-align: center;"
                  >
                    <template #body="slotProps">
                      <Button
                        v-if="slotProps.data.user_email != user_login"
                        icon="pi pi-trash"
                        class="p-button-rounded p-button-danger button-margin-right"
                        @click="confirmDeleteUser(slotProps.data)"
                      />
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Vue from "vue";
import { Auth } from "aws-amplify";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Toast from "primevue/toast";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import RadioButton from "primevue/radiobutton";
import InputNumber from "primevue/inputnumber";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Textarea from "primevue/textarea";
import Avatar from "primevue/avatar";
import Tag from "primevue/tag";
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import ProgressSpinner from "primevue/progressspinner";

class User {
  constructor(user_email, profile_id) {
    this.user_email = user_email;
    this.profile_id = profile_id;
  }
}

export default {
  data() {
    return {
      user_login: "",
      editingCellRows: {},
      editingRows: [],
      users: [],
      user_model: new User("", ""),
      profiles: [],
      principal_data_table_loading: true,
      filters: {},
      edit_user_profile: false,
      userDialog: false,
      newUserSubmitted: false,
      load_creation: false,
      invalid: {
        user_email: false,
        profile_id: false,
      },
      dropdown_profile_value: "",
      user: {},
      deleteUserDialog: false,
      can_show_actions: false,
    };
  },
  async mounted() {
    this.getUsers();
    this.getProfiles();
    let user = await Auth.currentAuthenticatedUser();

    const { attributes } = user;
    this.user_login = attributes.email;
  },
  created() {
    this.originalRows = {};
  },
  methods: {
    saveNewUser() {
      this.newUserSubmitted = true;
      this.invalid.user_email =
        this.user_model.user_email.trim().length == 0 ? true : false;
      this.invalid.profile_id =
        this.user_model.profile_id.trim().length == 0 ? true : false;

      if (!this.invalid.user_email && !this.invalid.profile_id) {
        this.createUser();
      }
    },
    async signUp() {
      try {
        const { user } = await Auth.signUp({
          username: this.user_model.user_email,
          password: "12345678",
          attributes: {
            profile: this.user_model.profile_id,
          },
        });
        return user;
        // console.log(user);
      } catch (error) {
        // console.log("error signing up:", error);
        return error;
      }
    },
    async createUser() {
      this.load_creation = true;
      let token = this.getToken();
      this.signUp()
        .then((user) => {
          // console.log(user);
          if (user.code == "UsernameExistsException") {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "This user already exists, please verify the email.",
              life: 5000,
            });
            this.load_creation = false;
          } else {
            this.axios
              .post(`${process.env.VUE_APP_USERS}`, this.user_model, {
                headers: { authorization: `Bearer ${token}` },
              })
              .then((res) => {
                // console.log(res.data);
                this.$toast.add({
                  severity: "success",
                  summary: "User Created",
                  detail: "User has been created successfully.",
                  life: 5000,
                });
              })
              .catch((error) => {
                // console.log(error);
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail:
                    "An error occurred while creating the user, please try again later.",
                  life: 5000,
                });
              })
              .finally(() => {
                this.userDialog = false;
                this.user_model = {
                  user_email: "",
                  profile_id: "",
                };
                this.load_creation = false;
                this.getUsers();
              });
          }
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while creating the user, please try again later.",
            life: 5000,
          });
        });
    },
    hideUserDialog() {
      this.userDialog = false;
      this.newUserSubmitted = false;
    },
    openUserDialog() {
      this.userDialog = true;
      this.newUserSubmitted = false;
    },
    getSingleProfile(profile_id) {
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_PROFILES}/${profile_id}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data["profile_name"]);
          this.dropdown_profile_value = res.data["profile_name"];
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    getProfiles() {
      // this.principal_data_table_loading = true;
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_PROFILES}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          let result_profiles = res.data;
          this.profiles = [];
          result_profiles.forEach((element) => {
            this.profiles.push({
              label: element.profile_name,
              value: element.profile_id,
            });
          });
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          // this.principal_data_table_loading = false;
        });
    },
    getUsers() {
      this.principal_data_table_loading = true;
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_USERS}?depth=true`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.users = res.data;
          this.users = this.users.filter(data=>{
            return !data.user_email.includes("nedi")
          })
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          if (this.users.length > 0) {
            this.principal_data_table_loading = false;
          }
          this.can_show_actions = true;
        });
    },
    getToken() {
      let token = localStorage.getItem("idToken");
      return token;
    },
    onRowEditInit(event) {
      this.originalRows[event.index] = { ...this.users[event.index] };
    },
    onRowEditCancel(event) {
      this.getUsers();
    },
    onRowEditSave(event) {
      let user_id = event.data.user_id;
      let user_data = event.data;
      delete user_data.user_id;
      delete user_data.profile_details;
      delete user_data.user_email;
      this.updateUser(user_id, user_data);
    },
    async updateUser(user_id, body) {
      this.principal_data_table_loading = true;
      // console.log(result);
      let token = this.getToken();
      this.axios
        .put(`${process.env.VUE_APP_USERS}/${user_id}`, body, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "User Updated",
            detail: "User has been successfully updated.",
            life: 5000,
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while updating the user, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.getUsers();
        });
    },
    confirmDeleteUser(user) {
      this.user = user;
      this.deleteUserDialog = true;
    },
    deleteSelectedUser() {
      let token = this.getToken();
      this.deleteUserDialog = false;
      this.principal_data_table_loading = true;
      this.axios
        .delete(`${process.env.VUE_APP_USERS}/${this.user.user_id}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Deleted data",
            detail: "The selected data was deleted successfully.",
            life: 5000,
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while deleting the user, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.getUsers();
        });
    },
  },
  components: {
    DataTable,
    Column,
    Toast,
    InputText,
    Toolbar,
    RadioButton,
    InputNumber,
    Button,
    Dialog,
    Textarea,
    Avatar,
    Tag,
    Dropdown,
    InputSwitch,
    ProgressSpinner,
  },
};
</script>
<style scoped>
.input-full-width {
  width: -webkit-fill-available;
}
.column-header {
  width: 175px;
}
.column-body {
  width: 175px;
}
.edit-column-body {
  width: 175px;
}
.edit-column-header {
  width: 175px;
}
</style>